<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">HHG Delinquency Report</legend>
    </div>
  </div>

  <form id="iffdelindReportGroup" role="form" [formGroup]="iffDelinqReport" (ngSubmit)="getIFFDelinqReport()">
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingYrSelect" class="usa-label">Reporting Calender Year<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingYrSelect" class="usa-select width-full" formControlName='reportingYrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          @for (reportingYrSingle of reportingYrList; track reportingYrSingle) {
            <option [value]="reportingYrSingle">
            {{reportingYrSingle}}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="reportingQtrSelect" class="usa-label">Reporting Quarter<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingQtrSelect" class="usa-select width-full" formControlName='reportingQtrSelect' (change)="getDelinqEmailStatus();">
          <option hidden value=''>Choose...</option>
          @for (qtr of this.printQtrList; track qtr) {
            <option [value]="qtr.value">{{qtr.name}}</option>
          }
        </select>
      </div>
      @if (showDelinqMessage) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <button type="button" class="usa-button usa-button--secondary margin-top-7" [disabled]="this.iffDelinqReport.invalid" (click)="sendDelinquentEmails();">Send Delinquent Emails</button>&nbsp;<br>
          <label class="maxw-full text-bold">{{ emailStatusMessage }}</label>
        </div>
      }
    </div>
    <div class="grid-row grid-gap padding-top-2 padding-bottom-4">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <button type="button" class="usa-button" type="submit" [disabled]="this.iffDelinqReport.invalid">Search</button>
      </div>
    </div>
    @if (rowData && rowData.length>0) {
      <div class="grid-row grid-gap padding-bottom-205">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
        </div>
      </div>
    }
    <div>
      <ag-grid-angular class="ag-theme-alpine" [columnDefs]="columnsDefs" [gridOptions]="gridOptions" [rowData]="rowData" [suppressDragLeaveHidesColumns]="true" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </form>

</div>
